import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/desktop/45_halloween_sky/45_halloween_sky"
 * Contains 1 texture(s)
 */
export class Desktop45HalloweenSkyAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/desktop/45_halloween_sky/45_halloween_sky';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '45_halloween_sky.jpg'
    ] as const;
}
